import Symbol from '../symbol.js'
import * as colors from 'scoreboard-colors'

const format = str => {
  return str.replace(/\s+/g, '').trim()
}
export default class Cylinder extends Symbol {

  handles = [{
    defaults: [.5, .28],
    constraints: [
      .5, [0, .5]
    ],
    cursor: 'ns-resize'
  }]

  // TODO This is mostly copy/pasta from page.js. Refactor
  getPaths (data, dimensions, handles) {
    const color = data.color
    const lid = colors.adjustLightness(color, 35) // Solid fill, lid is lighter
    const id0 = `${this.id}-0-component`
    const id1 = `${this.id}-1-component`

    // The first component is the main sheet
    return [{
      path: this.main(dimensions, handles),
      id: id0,
      fill: this.getFillValue(id0, data.fill, color),
      gradient: {
        type: 'linearGradient',
        id: `shape-gradient-0-${this.id}`,
        x1: '0%',
        y1: '0%',
        x2: '100%',
        y2: '0%',
        stops: [
          { offset: '0%', color: colors.adjustLightness(color, 50) },
          { offset: '50%', color: color },
          { offset: '100%', color: colors.adjustLightness(color, -15) },
        ]
      }
    }, {
      // The second component is the lid
      path: this.lid(dimensions, handles),
      id: id1,
      fill: this.getFillValue(id1, data.fill, lid),
      gradient: {
        type: 'linearGradient',
        id: `shape-gradient-1-${this.id}`,
        x1: '80%',
        y1: '0%',
        x2: '0%',
        y2: '100%',
        stops: [
          { offset: '0%', color: colors.adjustLightness(color, 10) },
          { offset: '50%', color: colors.adjustLightness(color, 35) },
          { offset: '100%', color: colors.adjustLightness(color, 50) },
        ]
      }
    }, {
      path: this.outline(dimensions, handles),
      fill: 'none',
      styles: {
        'stroke': 'none', // overwrite it
      }
    }]
  }

  getFlattenedPaths (data, dimensions) {
    // When flattened, the cylinder is just a rectangle, set the handles
    // top the very top (i.e. `y = 0`)
    const paths = this.getPaths(data, dimensions, [[.5, 0]])
    paths.at(-1).fill = paths.at(0).fill
    return paths
  }

  outline (dimensions, handles) {
    const dy = (dimensions.height * handles[0][1]) / 2

    return format(`
      M 0,${dy}
      A ${dimensions.width / 2},${dy},0,0,1,${dimensions.width},${dy}
      L ${dimensions.width}, ${dimensions.height - dy}
      A ${dimensions.width / 2},${dy},0,0,1,0,${dimensions.height - dy}
      L 0, ${dy}
      Z
    `)
  }

  lid (dimensions, handles) {
    const dy = (dimensions.height * handles[0][1]) / 2

    return format(`
      M 0,${dy}
      A ${dimensions.width / 2},${dy},0,0,1,${dimensions.width},${dy}
      A ${dimensions.width / 2},${dy},0,0,1,0,${dy}
      Z
    `)
  }

  main (dimensions, handles) {
    const dy = (dimensions.height * handles[0][1]) / 2

    return format(`
      M 0,${dy}
      A ${dimensions.width / 2},${-dy},0,0,0,${dimensions.width},${dy}
      L ${dimensions.width}, ${dimensions.height - dy}
      A ${dimensions.width / 2},${dy},0,0,1,0,${dimensions.height - dy}
      L 0, ${dy}
      Z
    `)
  }

  textContainer (dimensions, handles) {
    const dy = (dimensions.height * handles[0][1]) / 2

    const height = dimensions.height - dy * 3

    return {
      width: dimensions.width,
      height,
      center: [dimensions.center[0], dy * 2 + height / 2]
    }
  }

}
